import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLoginToken } from '../../../../utils/storageUtils'
import { formatDateYMD, getDateDaysAgo } from '../../../../utils/dateFormatter'
import { getPlayerLiabilityStart } from '../../../../store/redux-slices/dashboard'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const usePlayerLiability = ({ selectedPortal, selectedClient }) => {
  const dispatch = useDispatch()
  const { playerLiablityLoading: loading, playerLiabilityData } = useSelector((state) => state.dashboard)
  const [dateOptions, setDateOptions] = useState('today')
  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const isInitialRender = useDidMountEffect()

  const loadPlayerLiabilities = () => {
    alert('working');
    dispatch(getPlayerLiabilityStart({
      isTenant: false,
      startDate: formatDateYMD(state.map(a => a.startDate)),
      endDate: formatDateYMD(state.map(a => a.endDate)),
      tenantId: selectedPortal,
      adminId: selectedClient,
      dateOptions
    }))
  }

  useEffect(() => {
    loadPlayerLiabilities()
  }, [state, selectedClient, selectedPortal])
  useEffect(() => {
    if (dateOptions !== 'custom' && !isInitialRender) loadPlayerLiabilities()
  }, [dateOptions])

  const getCsvDownloadUrl = () =>
  `${process.env.REACT_APP_API_URL}/api/admin/report/players-liability?adminId=${selectedClient}&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}&dateOptions=${dateOptions}&csvDownload=true&token=${getLoginToken()}`

  return {
    loadPlayerLiabilities,
    loading,
    setState,
    state,
    getCsvDownloadUrl,
    playerLiabilityData,
    dateOptions,
    setDateOptions
  }
}

export default usePlayerLiability
